<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title11"></a>
<div class="verse"><span>I hate the place. I hate the people.<br/> I hate the bloody niggers.<br/> Mustn’t call ’em that, you know.</span></div>
<div class="source"><span>—GRAHAM GREENE</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="verse"><span>Nothing fuels a good flirtation<br/> Like need and anger and desperation.</span></div>
<div class="source"><span>—AIMEE MANN</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="verse"><span>I keep a close watch on this heart of mine,<br/> I keep my eyes wide open all the time.</span></div>
<div class="source"><span>—JOHNNY CASH</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429998314_epi01.vue?0e3fcfa7